import styled from '../../styles/styledComponents/themeComponents';

export const PanelWrapperStyle = styled.section`
  margin-bottom: 0.8rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid #c2cfd6;
  width: 100%;
`;

export const PanelTitleStyle = styled.h2`
  padding: 0.7rem 1.3rem;
  background-color: transparent;
  border-bottom: 1px solid #c2cfd6;
  font-size: 16px;
  font-weight: 600;
  color: #495057;
`;

export const PanelBodyStyle = styled.div`
  flex: 1 1 auto;
  padding: 1.25rem;
`;

export const PanelSectionStyle = styled.div`
  border-bottom: 1px solid #efefef;
  padding: 20px 0;
  &:first-child {
    padding-top: 0;
  }
  &:last-child {
    border-bottom: none;
  }
`;
